import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Holds the "active center for CRM operations" — used by super-admins who can
 * pick which center's leads to see/lookup. For reps and managers this is null
 * and the auth-context centerId is used implicitly.
 *
 * Persisted to localStorage so the choice survives reload.
 */
interface CrmCenterState {
  selectedCenterId: string | null;
  setSelectedCenterId: (id: string | null) => void;
}

export const useCrmCenterStore = create<CrmCenterState>()(
  persist(
    set => ({
      selectedCenterId: null,
      setSelectedCenterId: id => set({ selectedCenterId: id }),
    }),
    { name: 'crm-center-store-v1' },
  ),
);
